import React, { PropsWithChildren, useCallback, useContext, useMemo } from 'react'
import { useNavigate } from 'react-router'
import OscAuthWrapper from '../Auth/OscAuthWrapper'
import OscContext from '../context/Osc'
import api from '../helpers/api'
import { SidenavUserData, LoggedTemplate } from '../Korbantech'
import { WHITE_LOGO, OSC_MENU_ITEMS } from '../utils/constants'

const OscLoggedLayout = ( { children, pageTitle }:Props ) => {
    const { state: user, setState: setUser  } = useContext( OscContext )
    const navigate = useNavigate()

    const logo = useMemo( () => {
        return WHITE_LOGO
    }, [ ])

    const logout = useCallback( async () => {
        if( !user ) return
        const headers = {
            Authorization: `Bearer ${user?.access_token}`
        }
        await api.get( 'client/auth/logout', { headers } ).then( () => {
            setUser( undefined )
            window.location.reload()
        }).catch( console.log )
    }, [ setUser, user ] )

    const userData:SidenavUserData = useMemo( () => {
        return {
            name: user?.corporate_name ?? '',
            logout,
            viewPerfilCallback:()=>navigate("/osc/meu-perfil")
        }
    }, [ user, logout,navigate ] )

    const menuItems = useMemo( () => {
        return OSC_MENU_ITEMS.map( menu => ({
            ...menu,
            action: () => menu.to  && navigate( menu.to )
        }))
    }, [ navigate ] )

    return(
    <OscAuthWrapper>
            <LoggedTemplate
                bg_color={'bg-primary'}
                sideNavUserColor={'bg-gray-50'}
                sideNavUserTextColor={'text-gray-800'}
                hoverColor={' bg-primary '}
                hoverText={' text-white '}
                textColor={'text-gray-800'}
                isLogged={ user !== undefined }
                brandLogoUrl={ logo }
                userData={ userData }
                menuItems={ menuItems }
                pageTitle={ pageTitle }
                viewPerfilCallback={()=>navigate("/osc/minha-conta")}
                us
            >
                <div className='px-12 mt-5 pt-7'>
                    {children}
                </div>
            </LoggedTemplate>
    </OscAuthWrapper>
    )
}

interface Props extends PropsWithChildren<any>{
    pageTitle?: string,
    useMallContext?: boolean
}

export { OscLoggedLayout }
